import { DefinitionsActionTypes  } from './definitions.types';

export const setFormChatStatus = (payload) => {
  return dispatch => {
    dispatch({ type:DefinitionsActionTypes.SET_CHATFORM_STATUS, formChatOpenStatus: payload})
  }
}